(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["background-image-text"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const section = document.currentScript?.closest('.shopify-section')?.querySelector('.background-image-text-section');

    if (!section || section.dataset.parallax !== 'true') return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    const media = section.querySelector('[data-background-media]');
    if (!media) return;

    let ticking = false;

    const updateParallax = () => {
      const rect = section.getBoundingClientRect();
      const progress = (window.innerHeight - rect.top) / (window.innerHeight + rect.height);
      const shift = (progress - 0.5) * 28;
      const axis = getComputedStyle(section).getPropertyValue('--background-image-text-parallax-axis').trim();

      if (axis === 'horizontal') {
        media.style.transform = `translate3d(${shift}px, 0, 0) scale(1.06)`;
      } else {
        media.style.transform = `translate3d(0, ${shift}px, 0) scale(1.06)`;
      }
      ticking = false;
    };

    const requestUpdate = () => {
      if (window.innerWidth <= 749) {
        media.style.transform = 'none';
        return;
      }

      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(updateParallax);
    };

    updateParallax();
    document.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', requestUpdate);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq"] && !Shopify.designMode) return;
  try {
    
  class FaqSection extends HTMLElement {
    connectedCallback() {
      this._items = Array.from(this.querySelectorAll('details.faq-item'));
      this._items.forEach((item) => {
        item.addEventListener('toggle', () => {
          if (item.open) {
            this._items.forEach((other) => {
              if (other !== item) other.removeAttribute('open');
            });
          }
        });
      });
    }
  }

  if (!customElements.get('faq-section')) {
    customElements.define('faq-section', FaqSection);
  }

  } catch(e) { console.error(e); }
})();
})();
